import React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import {
    Dialog,
    DialogOverlay,
    DialogPortal,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
} from "../ui/dialog";
// Note: DialogContent from dialog.jsx has a hardcoded Close X button that we don't want
// in alert dialogs. We use DialogPrimitive.Content directly below to avoid it.
import { Button } from "../ui/button";

const DeleteConfirmation = ({
    isOpen,
    onClose,
    onConfirm,
    title = "Confirmer la suppression",
    description = "Voulez-vous vraiment supprimer cet élément ? Cette action est irréversible.",
    confirmText = "Supprimer",
    cancelText = "Annuler",
}) => {
    return (
        <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onClose(); }}>
            <DialogPortal>
                <DialogOverlay />
                <DialogPrimitive.Content
                    role="alertdialog"
                    className="fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 sm:rounded-lg"
                    onEscapeKeyDown={onClose}
                    onInteractOutside={(e) => e.preventDefault()}
                >
                    <DialogHeader>
                        <DialogTitle>{title}</DialogTitle>
                        <DialogDescription>
                            {description}
                        </DialogDescription>
                    </DialogHeader>
                    <DialogFooter>
                        <Button variant="outline" onClick={onClose}>
                            {cancelText}
                        </Button>
                        <Button variant="destructive" onClick={onConfirm}>
                            {confirmText}
                        </Button>
                    </DialogFooter>
                </DialogPrimitive.Content>
            </DialogPortal>
        </Dialog>
    );
};

export default DeleteConfirmation;
